/* eslint-disable react/no-array-index-key */
import React, { memo, useMemo } from 'react';
import shortid from 'shortid';

import ThemedScrollDiv from 'common/ThemedScrollDiv';

import TableHead from '../ThemedTable/TableHead';
import TableFooter from '../ThemedTable/TableFooter';
import RowRenderer from './RowRenderer';
import ThemedTable from '../ThemedTable';

import './SmartTable.scss';

const SmartTable = ({
  matrix,
  head,
  colSpan = () => 1,
  renderBeginColumns,
  renderEndColumns,
  renderCell,
  className,
  rowClassName,
  footer,
  footerCell,
  footerClassName,
  shouldHighlightRow,
}) => {
  const id = useMemo(() => shortid.generate(), []);

  return (
    <ThemedScrollDiv orientation="horizontal" className={className}>
      <ThemedTable>
        <thead>
          <TableHead cells={head} />
        </thead>
        <tbody className="SmartTable__body">
          {matrix?.map((row, i) => (
            <RowRenderer
              key={`[RowRenderer] ${id} ${i}`}
              renderCell={renderCell}
              renderBeginColumns={renderBeginColumns}
              renderEndColumns={renderEndColumns}
              row={row}
              shouldHighlightRow={shouldHighlightRow && shouldHighlightRow(row, i)}
              index={i}
              className={rowClassName}
              colSpan={colSpan(i)}
            />
          ))}
        </tbody>
        {footer?.length > 0 && (
          <tfoot>
            <TableFooter
              className={footerClassName}
              footer={footer}
              footerCell={footerCell}
              colSpan={colSpan(matrix?.data?.length)}
            />
          </tfoot>
        )}
      </ThemedTable>
    </ThemedScrollDiv>
  );
};

export default memo(SmartTable);
